import { BOOKING_STATUSES } from "../../../../../../../consts/booking"

export const mapperBookingStatus = (status, blockers) => {
  const isCredentialsSharingLock = blockers.find(
    (blocker) =>
      blocker.status === "active" &&
      ["booking_handover", "booking_handover_manual"].includes(blocker.name),
  )
  return isCredentialsSharingLock ? BOOKING_STATUSES.LOCKED : status
}
